import type { Variants, Transition } from 'framer-motion';

export const easeStripe = [0.32, 0.72, 0, 1] as const;
export const easeSpring = [0.16, 1, 0.3, 1] as const;

export const transitionSmooth: Transition = {
  duration: 0.6,
  ease: easeStripe,
};

export const transitionSnappy: Transition = {
  duration: 0.35,
  ease: easeStripe,
};

export const variantsFadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: transitionSmooth },
};

export const variantsFadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: transitionSmooth },
};

export const variantsScaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: transitionSmooth },
};

export const variantsStaggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.1 },
  },
};

export const variantsStaggerItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: transitionSmooth },
};
